import { ChakraBox } from '@equip.health/ui';
import Header from '~/components/common/Header';
import { PAGE_LAYOUT, PAGE_TOP_PADDING } from '~/lib/constants';

const healthGorillaLanding = () => (
  <ChakraBox
    paddingRight={PAGE_LAYOUT.rightSpacing}
    paddingTop={PAGE_TOP_PADDING}
  >
    <Header title="Health Gorilla" />
  </ChakraBox>
);
export default healthGorillaLanding;
